import React from "react"

import "./scss/main.scss"

const Footer = () => (
  <div id="footer-container">
    <div className="container">
      <div id="footer" className="row">
        <div className="col-6 col-lg-4">
          <ul className="list-unstyled">
            <li>
              <img src="/images/icon-address-localisation.png" alt="Localisation icon" />
              280, rue Paul Sabatier<br />
              Parc d’activités Port l’Ardoise<br />
              30290 Laudun l’Ardoise
            </li>
            <li><img src="/images/icon-address-phone.png" alt="Phone icon" /> 04 66 90 52 00</li>
            <li>
              <img src="/images/icon-address-email.png" alt="Email icon" />
              <a href="mailto:contact@dropcv.fr">contact@dropcv.fr</a>
            </li>
          </ul>
        </div>
        <div className="col-6 col-lg-4 text-center">
          <img src="/images/dropcv-logo-white.png" alt="DropCV" />
          <a href="https://twitter.com/DropCV2017" target="_blank" rel="noreferrer"><img src="/images/icon-social-twitter.png" alt="DropCV sur Twitter" /></a>
          <a href="https://www.facebook.com/dropcv" target="_blank" rel="noreferrer"><img src="/images/icon-social-facebook.png" alt="DropCV sur Facebook" /></a>
          <a href="https://fr.linkedin.com/company/drop-cv" target="_blank" rel="noreferrer"><img src="/images/icon-social-linkedin.png" alt="DropCV sur LinkedIn" /></a>
        </div>
        <div className="d-lg-block col-lg-4"></div>
      </div>
    </div>
  </div>
)
export default Footer
